var map = {
	"./404.svg": "sEM+",
	"./alarm.svg": "mMjV",
	"./box.svg": "N5kO",
	"./bug.svg": "SVqS",
	"./chart.svg": "RjYk",
	"./clipboard.svg": "KO/S",
	"./component.svg": "s2cW",
	"./dashboard.svg": "BCGP",
	"./database.svg": "T380",
	"./documentation.svg": "zUKd",
	"./drag.svg": "vRhf",
	"./edit.svg": "ql+d",
	"./email.svg": "+4G4",
	"./example.svg": "OOLB",
	"./excel.svg": "OLl3",
	"./exit-fullscreen.svg": "G+/G",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./fence.svg": "WBhp",
	"./filter.svg": "ObMl",
	"./form.svg": "sTIr",
	"./fullscreen.svg": "WIff",
	"./goods.svg": "XNJ4",
	"./guide 2.svg": "kA1i",
	"./guide.svg": "z74U",
	"./home.svg": "U9Ws",
	"./icon.svg": "vUvT",
	"./international.svg": "SBEl",
	"./language.svg": "+Dip",
	"./link.svg": "KgwQ",
	"./list.svg": "vuHp",
	"./lock.svg": "FnAU",
	"./logs.svg": "49QO",
	"./message.svg": "G2zY",
	"./money.svg": "ig9B",
	"./nested.svg": "798r",
	"./order.svg": "gYtG",
	"./page.svg": "zrC5",
	"./password.svg": "QjmH",
	"./paycheck.svg": "+Mec",
	"./pdf.svg": "M8Oc",
	"./people.svg": "GPe0",
	"./peoples.svg": "TgHK",
	"./qq.svg": "R2jY",
	"./qr.svg": "YeP7",
	"./recycling.svg": "ieY1",
	"./report.svg": "2nwU",
	"./search.svg": "Bx0U",
	"./service.svg": "nCjf",
	"./setting.svg": "Kttn",
	"./shopping.svg": "jRi0",
	"./sign.svg": "HE8u",
	"./size.svg": "Cr4N",
	"./star.svg": "60zo",
	"./tab.svg": "Jysk",
	"./table-setting.svg": "hTsv",
	"./table.svg": "oSYw",
	"./theme.svg": "hdtf",
	"./transport.svg": "EGRk",
	"./tree.svg": "3eCm",
	"./user.svg": "VdD3",
	"./warehouse.svg": "BupX",
	"./wechat.svg": "pYJ+",
	"./zip.svg": "0DNV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 113